import { useState } from 'react';
import Principal from './../Principal';
import Usuarios from '../../secundarios/Usuarios/Usuarios';
import Contabilidad from '../../secundarios/Contabilidad/Contabilidad';
import Inventario from '../../secundarios/Inventario/Inventario';
import Personal from '../../secundarios/Personal/Personal';
import BarraNavegacion from './barraNavegacion';
import Fichaje from '../../secundarios/Fichar/Fichaje'; // Importamos el formulario de Fichaje
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, Typography } from '@mui/material';
import './Inicio.css';

function Inicio() {
    const [actualizarDisponibles, setActualizarDisponibles] = useState(false);
    const [mostrarFichaje, setMostrarFichaje] = useState(false);
    const [componenteActivo, setComponenteActivo] = useState('principal');

    // Estado para manejar login Contabilidad
    const [mostrarLoginContabilidad, setMostrarLoginContabilidad] = useState(false);
    const [contabilidadAutorizado, setContabilidadAutorizado] = useState(false);
    const [errorLoginContabilidad, setErrorLoginContabilidad] = useState('');

    // Estado para manejar login Personal
    const [mostrarLoginPersonal, setMostrarLoginPersonal] = useState(false);
    const [personalAutorizado, setPersonalAutorizado] = useState(false);
    const [errorLoginPersonal, setErrorLoginPersonal] = useState('');
const [salonSeleccionado, setSalonSeleccionado] = useState(1);

    // Función para abrir el modal de fichaje
    const handleOpenFichaje = () => {
        setMostrarFichaje(true);
    };

    // Función para actualizar disponibles
    const handleActualizarDisponibles = () => {
        setActualizarDisponibles(prevState => !prevState);
    };

    // Función para cerrar modal fichaje y actualizar
    const handleCloseFichaje = () => {
        setMostrarFichaje(false);
        handleActualizarDisponibles();
    };

    // Manejo del cambio de sección con control para Contabilidad y Personal
    const handleCambiarComponente = (componente) => {
        if (componente === 'contabilidad') {
            if (contabilidadAutorizado) {
                setComponenteActivo(componente);
            } else {
                setMostrarLoginContabilidad(true);
                setErrorLoginContabilidad('');
            }
        } else if (componente === 'personal') {
            if (personalAutorizado) {
                setComponenteActivo(componente);
            } else {
                setMostrarLoginPersonal(true);
                setErrorLoginPersonal('');
            }
        } else {
            setComponenteActivo(componente);
        }
    };

    // Login contabilidad
    const handleLoginContabilidad = async (id_login_empleado, contraseña) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/login-contabilidad`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id_login_empleado, contraseña }),
            });
            const data = await response.json();

            if (response.ok) {
                // Validamos que el id_empleado sea 2 o 4 (los autorizados)
                if (data.id_empleado === 2 || data.id_empleado === 4) {
                    setContabilidadAutorizado(true);
                    setMostrarLoginContabilidad(false);
                    setComponenteActivo('contabilidad');
                    setErrorLoginContabilidad('');
                } else {
                    setErrorLoginContabilidad('No tiene permisos para acceder a Contabilidad.');
                }
            } else {
                setErrorLoginContabilidad(data.message || 'Error en login');
            }
        } catch (error) {
            setErrorLoginContabilidad('Error de conexión con el servidor');
        }
    };

    // Login personal
    const handleLoginPersonal = async (id_login_empleado, contraseña) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/login-contabilidad`, {  // Cambia la URL si es necesario
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id_login_empleado, contraseña }),
            });
            const data = await response.json();

            if (response.ok) {
                // Ejemplo: validar id_empleado autorizado para personal (ajusta según tu lógica)
                // Aquí validamos id_empleado 3 y 5 como autorizados, cambia según corresponda
                if (data.id_empleado === 2 || data.id_empleado === 4) {
                    setPersonalAutorizado(true);
                    setMostrarLoginPersonal(false);
                    setComponenteActivo('personal');
                    setErrorLoginPersonal('');
                } else {
                    setErrorLoginPersonal('No tiene permisos para acceder a Personal.');
                }
            } else {
                setErrorLoginPersonal(data.message || 'Error en login');
            }
        } catch (error) {
            setErrorLoginPersonal('Error de conexión con el servidor');
        }
    };

    // Modal login genérico para Contabilidad y Personal
    const LoginModal = ({ title, onLogin, onCancel, error }) => {
        const [id_login_empleado, setIdLoginEmpleado] = useState('');
        const [contraseña, setContraseña] = useState('');

        const handleSubmit = (e) => {
            e.preventDefault();
            onLogin(id_login_empleado, contraseña);
        };

        return (
            <Dialog open onClose={onCancel}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem', marginTop: '1rem' }}>
                        <TextField
                            label="ID Usuario"
                            variant="outlined"
                            value={id_login_empleado}
                            onChange={e => setIdLoginEmpleado(e.target.value)}
                            required
                            autoFocus
                        />
                        <TextField
                            label="Contraseña"
                            variant="outlined"
                            type="password"
                            value={contraseña}
                            onChange={e => setContraseña(e.target.value)}
                            required
                        />
                        {error && (
                            <Typography color="error" variant="body2">{error}</Typography>
                        )}
                        <DialogActions>
                            <Button onClick={onCancel}>Cancelar</Button>
                            <Button type="submit" variant="contained" color="primary">
                                Iniciar sesión
                            </Button>
                        </DialogActions>
                    </form>
                </DialogContent>
            </Dialog>
        );
    };

    return (
        <div className="app-container">
            {/* Barra de navegación */}
      <BarraNavegacion 
  componenteActivo={componenteActivo}
  setComponenteActivo={handleCambiarComponente}
  salonSeleccionado={salonSeleccionado}
  setSalonSeleccionado={setSalonSeleccionado}
/>
            {/* Contenedor donde se renderiza el componente activo */}
            <div className="content-container">
                {componenteActivo === 'principal' && (
                    <Principal
                        actualizarDisponibles={handleActualizarDisponibles}
                        setMostrarFichaje={handleOpenFichaje}
                        salonSeleccionado={salonSeleccionado}  // <-- Aquí lo pasas
                    />
                )}
                {componenteActivo === 'usuarios' && <Usuarios />}
                {componenteActivo === 'contabilidad' && <Contabilidad />}
                {componenteActivo === 'inventario' && <Inventario />}
                {componenteActivo === 'personal' && <Personal />}
            </div>

            {/* Modal de Fichaje */}
            <Dialog open={mostrarFichaje} onClose={handleCloseFichaje}>
                <DialogTitle>Formulario de Fichaje</DialogTitle>
                <DialogContent>
                    <Fichaje setMostrarFichaje={handleCloseFichaje} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseFichaje} color="primary">
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Modal login Contabilidad */}
            {mostrarLoginContabilidad && (
                <LoginModal
                    title="Login para Contabilidad"
                    onLogin={handleLoginContabilidad}
                    onCancel={() => setMostrarLoginContabilidad(false)}
                    error={errorLoginContabilidad}
                />
            )}

            {/* Modal login Personal */}
            {mostrarLoginPersonal && (
                <LoginModal
                    title="Login para Personal"
                    onLogin={handleLoginPersonal}
                    onCancel={() => setMostrarLoginPersonal(false)}
                    error={errorLoginPersonal}
                />
            )}
        </div>
    );
}

export default Inicio;
